/**
 *
 * CapCustomCarousel
 *
 */

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './_capCustomCarousel.scss';
import CapRow from '../CapRow';
import CapHeading from '../CapHeading';

const CapCustomCarousel = props => {
  const { className, carouselData, ...rest } = props;
  const [carouselItemIndex, setCarouselItemIndex] = useState(0);
  const carouselId = Math.random()
    .toString(36)
    .substr(2, 9);
  const handleSlidesOnAction = index => {
    const carouselContainer = document.querySelector(
      `.cap-custom-carousel-container-${carouselId}`,
    );
    const carouselItem = document.querySelector(
      `[data-index="${index}-${carouselId}"]`,
    );
    const scrollOffset = carouselItem.offsetLeft - carouselContainer.offsetLeft;
    carouselContainer.scrollTo({
      left: scrollOffset,
      behavior: 'smooth',
    });
  };
  const handleSlidesOnScroll = (carouselContainer, itemsWithDataIndex) => {
    itemsWithDataIndex.forEach(carouselItem => {
      if (
        carouselContainer?.scrollLeft +
          parseInt(carouselContainer?.clientWidth * 0.3, 10) >=
        carouselItem?.offsetLeft
      ) {
        setCarouselItemIndex(parseInt(carouselItem?.dataset?.index, 10));
      }
    });
  };
  useEffect(() => {
    const carouselContainer = document.querySelector(
      `.cap-custom-carousel-container-${carouselId}`,
    );
    const itemsWithDataIndex = document.querySelectorAll(
      `[data-carousel="${carouselId}"]`,
    );
    carouselContainer.addEventListener(
      'scroll',
      handleSlidesOnScroll.bind(null, carouselContainer, itemsWithDataIndex),
    );
    return () => {
      carouselContainer.removeEventListener(
        'scroll',
        handleSlidesOnScroll.bind(null, carouselContainer, itemsWithDataIndex),
      );
    };
  }, []);

  return (
    <CapRow className={className}>
      <CapHeading className="cap-custom-carousel-heading-label" type="h1">
        {carouselData?.carouselHeading}
      </CapHeading>
      <CapRow
        type="flex"
        className="cap-custom-carousel-header"
        data-testid="cap-custom-carousel-header"
      >
        {carouselData?.scrollCards?.map(({ cardHeading }, index) => (
          <CapRow
            className={classnames('cap-custom-carousel-header-item', {
              'cap-custom-carousel-header-item-selected':
                carouselItemIndex === index,
            })}
            style={{
              flexBasis: `${parseInt(
                100 / carouselData?.scrollCards?.length,
                10,
              )}%`,
            }}
            data-testid={`header-${index}`}
            onClick={() => {
              handleSlidesOnAction(index);
            }}
            key={index}
          >
            <span>{cardHeading}</span>{' '}
          </CapRow>
        ))}
      </CapRow>
      <CapRow
        type="flex"
        className={classnames(
          'cap-custom-carousel-container',
          `cap-custom-carousel-container-${carouselId}`,
        )}
        style={{
          gap: carouselData?.cardsGap ? carouselData?.cardsGap : '0.8rem',
        }}
      >
        {carouselData?.scrollCards &&
          carouselData?.scrollCards.map(({ card }, index) => (
            <CapRow
              data-carousel={`${carouselId}`}
              data-index={`${index}-${carouselId}`}
              key={index}
            >
              {card}
            </CapRow>
          ))}
      </CapRow>
    </CapRow>
  );
};

CapCustomCarousel.defaultProps = {
  carouselData: {},
};
CapCustomCarousel.propTypes = {
  carouselData: PropTypes.object.isRequired,
};

export default CapCustomCarousel;
